"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeTabs = exports.generateNavCategories = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _filterNav = _interopRequireDefault(require("../../../elements/other/filter-nav"));
var _react2 = require("@linaria/react");
var _productTabCard = _interopRequireDefault(require("./product-tab-card"));
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h14oqgfw"
});
const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-n1co53ae"
});
const CardGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardGroup",
  class: "pl-cveewxv"
});

/**
 * Normalizes tab data from either the new format or legacy format
 *
 * @param {Array} tabs Tabs in the new format
 * @param {Array} categories Categories for legacy format
 * @param {Array} cardSets CardSets for legacy format
 * @returns {Array} Normalized tabs with consistent structure
 */
const normalizeTabs = (tabs, categories, cardSets) => {
  const isLegacyFormat = !tabs && Array.isArray(cardSets);
  if (isLegacyFormat) {
    if (Array.isArray(categories)) {
      return categories.map((category, index) => ({
        label: category.filterName,
        cards: cardSets[index]?.cards || []
      }));
    }
    return cardSets.map((set, index) => ({
      label: `Tab ${index + 1}`,
      cards: set.cards || []
    }));
  }
  return tabs;
};

/**
 * Generates navigation categories from normalized tabs
 *
 * @param {Array} normalizedTabs Array of normalized tabs
 * @returns {Array} Navigation categories for FilterNav
 */
exports.normalizeTabs = normalizeTabs;
const generateNavCategories = normalizedTabs => {
  if (!normalizedTabs || !Array.isArray(normalizedTabs)) {
    return [];
  }
  return normalizedTabs.map((tab, index) => ({
    id: `tab-${index}`,
    _name: `navitem_${tab.label?.toLowerCase().replace(/\s+/g, '_')}`,
    filterName: tab.label
  }));
};

/**
 * Product Tabbed Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking name of the component
 * @param {React.ReactNode} props.headlineLockup Headline Lockup component
 * @param {String} props.heading Headline text (alternative to headlineLockup)
 * @param {String} props.verticalMargin Vertical Outer Spacing value
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @param {Array} props.tabs Card Sets for the cards in new format
 * @param {Array} props.categories Categories for the cards (legacy format)
 * @param {Array} props.cardSets Card Sets for the cards (legacy format)
 * @param {Boolean} props.newMobileLayout New mobile layout for the cards
 * @returns {React.ReactElement} Product Tabbed Component
 * @public
 */
exports.generateNavCategories = generateNavCategories;
function ProductTabbedSection({
  _name,
  headlineLockup,
  heading,
  tabs,
  categories,
  cardSets,
  verticalMargin,
  verticalPadding = 'small',
  newMobileLayout = false
}) {
  const [selectedTabIndex, setSelectedTabIndex] = (0, _react.useState)(0);
  const normalizedTabs = (0, _react.useMemo)(() => normalizeTabs(tabs, categories, cardSets), [tabs, categories, cardSets]);
  const navCategories = (0, _react.useMemo)(() => generateNavCategories(normalizedTabs), [normalizedTabs]);
  if (!normalizedTabs || !Array.isArray(normalizedTabs) || normalizedTabs.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Section does not have any tabs.");
  }
  const hasTabs = normalizedTabs.length > 1;
  const hasHeadline = Boolean(heading) || /*#__PURE__*/_react.default.isValidElement(headlineLockup);
  const selectedTab = normalizedTabs[selectedTabIndex];
  const layoutCondition = selectedTab?.cards?.length === 3 ? 'three-columns' : 'two-columns';
  const handleTabChange = e => {
    const index = Number(e.target.value);
    setSelectedTabIndex(index);
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "product-tabbed-section",
    padding: "none",
    verticalPadding: verticalPadding,
    verticalMargin: verticalMargin,
    backgroundColor: _intents.default.ux.box.backgroundColor
  }, hasHeadline ? /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.isValidElement(headlineLockup) ? (/*#__PURE__*/_react.default.cloneElement(headlineLockup, {
    headlineTag: 'h2',
    headlineSize: 'h2',
    headlineLineLength: 2
  })) : /*#__PURE__*/_react.default.createElement(_headlineLockup.default, {
    headlineTag: "h2",
    headlineSize: "h2",
    headlineLineLength: 2,
    heading: heading
  })) : null, hasTabs ? /*#__PURE__*/_react.default.createElement(NavContainer, null, /*#__PURE__*/_react.default.createElement(_filterNav.default, {
    dataCy: "filter-nav",
    showScrollbar: true,
    categories: navCategories,
    handleAction: handleTabChange,
    selected: selectedTabIndex
  })) : null, /*#__PURE__*/_react.default.createElement(CardGroup, {
    "data-cy": "card-grid",
    className: `${layoutCondition} ${!newMobileLayout ? 'legacy-layout' : ''}`
  }, normalizedTabs?.[selectedTabIndex]?.cards?.map((card, index) => /*#__PURE__*/_react.default.createElement(_productTabCard.default, (0, _extends2.default)({
    key: index,
    newMobileLayout: newMobileLayout
  }, card)))));
}
ProductTabbedSection.propTypes = {
  _name: _propTypes.default.string.isRequired,
  headlineLockup: _propTypes.default.node,
  heading: _propTypes.default.string,
  tabs: _propTypes.default.array,
  categories: _propTypes.default.array,
  cardSets: _propTypes.default.array,
  ..._patternLibraryUtils.paddingProps,
  ..._patternLibraryUtils.marginProps,
  newMobileLayout: _propTypes.default.bool
};
var _default = exports.default = ProductTabbedSection;